import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft } from 'lucide-react';
import api from '../api/axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';

export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.post('/auth/forgot-password', { email });
      setEmailSent(true);
      toast.success('Email enviado. Revisa tu bandeja de entrada.');
    } catch (error) {
      toast.error('Error al enviar email. Intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="forgot-password-page">
      <Card className="max-w-md w-full glass-effect border-white/10">
        <CardHeader>
          <div className="mb-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_virtualgolf-2/artifacts/si8l522g_IMG_1926.png" 
              alt="City Virtual Golf" 
              className="h-16 w-auto mx-auto mb-4"
            />
          </div>
          <CardTitle className="text-3xl font-heading font-bold uppercase tracking-tight text-center" data-testid="forgot-password-title">
            Recuperar Contraseña
          </CardTitle>
          <CardDescription className="text-center mt-2" data-testid="forgot-password-subtitle">
            {emailSent 
              ? 'Email enviado exitosamente'
              : 'Ingresa tu email para recibir un enlace de recuperación'
            }
          </CardDescription>
        </CardHeader>

        <CardContent>
          {emailSent ? (
            <div className="space-y-4">
              <div className="p-4 bg-primary/10 border border-primary/30 rounded-lg text-center" data-testid="email-sent-message">
                <Mail className="h-12 w-12 text-primary mx-auto mb-3" />
                <p className="font-semibold mb-2">¡Revisa tu email!</p>
                <p className="text-sm text-muted-foreground">
                  Enviamos un enlace de recuperación a <strong>{email}</strong>
                </p>
                <p className="text-xs text-muted-foreground mt-3">
                  Si no lo ves, revisa tu carpeta de spam
                </p>
              </div>

              <Link 
                to="/login" 
                className="flex items-center justify-center gap-2 text-accent hover:underline"
                data-testid="back-to-login-link"
              >
                <ArrowLeft className="h-4 w-4" />
                Volver al inicio de sesión
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6" data-testid="forgot-password-form">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="tu-email@ejemplo.com"
                  required
                  className="mt-1 bg-white/5 border-white/10"
                  data-testid="forgot-password-email-input"
                />
              </div>

              <Button 
                type="submit" 
                className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-bold uppercase tracking-wider"
                disabled={loading}
                data-testid="forgot-password-submit-button"
              >
                {loading ? 'Enviando...' : 'Enviar Enlace de Recuperación'}
              </Button>

              <Link 
                to="/login" 
                className="flex items-center justify-center gap-2 text-accent hover:underline"
                data-testid="back-to-login-link-form"
              >
                <ArrowLeft className="h-4 w-4" />
                Volver al inicio de sesión
              </Link>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
};